import React from 'react';
import RequestLeaves from '../../Leave-Management/request-leave/request-leaves';

const EmpoyeeLeaveRequestPresentational = ({ employeeDetails, isDataLoading }) => {
	return <RequestLeaves {...{ isEmployeeRequest: true, employeeDetails, isDataLoading }} />;
};

export default EmpoyeeLeaveRequestPresentational;
